import React from 'react'

const Checkmark = ({ width = '13px', height = '10px', fill = '#1555D0' }) => {
  return (
    <svg style={{ width, height, fill }} viewBox='0 0 13 10' version='1.1'>
      <title>checkmark</title>
      <g id='_symbols' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g
          id='forms/inputs/material/light/baseline/active-select'
          transform='translate(-264.000000, -23.000000)'
          fill={fill}
        >
          <polygon
            id='checkmark'
            points='277 25.0588235 274.931818 23 269.022727 28.8823529 266.068182 25.9411765 264 28 269.022727 33'
          ></polygon>
        </g>
      </g>
    </svg>
  )
}

export default Checkmark
